import { render, staticRenderFns } from "./DrugInteraction.vue?vue&type=template&id=ddd4afac&scoped=true&"
import script from "./DrugInteraction.vue?vue&type=script&lang=js&"
export * from "./DrugInteraction.vue?vue&type=script&lang=js&"
import style0 from "./DrugInteraction.vue?vue&type=style&index=0&id=ddd4afac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd4afac",
  null
  
)

export default component.exports